<ng-template #newPackageTemplate>
	<mod-package-form (create)="handleCreatePackage($event)" [isInDialog]="true"></mod-package-form>
</ng-template>

@if (assignPackagesButtons(); as assignPackagesButtons) {
<div class="push-bottom">
	<lib-button-list [buttons]="assignPackagesButtons"></lib-button-list>
</div>
}

<lib-card [title]="'Assigned packages'">
	<lib-list
		[items]="assignedPackageListItems()"
		[noItemsText]="authUserIsClient() ? 'You have no assigned packages' : 'Client has no assigned packages'"
	></lib-list>
</lib-card>
